import { Link } from "react-router"

const FaqSection = () => {
  return (
  <>
  {/* Start Faq Section */}
  <section className="section faq-section-fifteen">
    <div className="container">
      {/* start row */}
      <div className="row">
        <div className="col-xl-6 col-lg-5" />
        <div className="col-xl-6 col-lg-7">
          <div className="section-header section-header-fifteen">
            <h2 className="section-title">
              Commonly Asked <span>Questions</span>
            </h2>
          </div>
          <div
            className="faq-info faq-info-fifteen wow zoomIn"
            data-wow-duration="1s"
          >
            <div className="accordion" id="faq-details-one">
              {/* FAQ Item */}
              <div className="accordion-item">
                <h3 className="accordion-header" id="headingOne">
                  <Link
                    to="#"
                    className="accordion-button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseOne"
                    aria-expanded="true"
                    aria-controls="collapseOne"
                  >
                    Is virtual therapy right for me?
                  </Link>
                </h3>
                <div
                  id="collapseOne"
                  className="accordion-collapse collapse show"
                  data-bs-parent="#faq-details-one"
                >
                  <div className="accordion-body">
                    <div className="accordion-content">
                      <p>
                        We encourage regular sessions to track progress and
                        provide ongoing support. Frequency depends on individual
                        needs.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              {/* /FAQ Item */}
              {/* FAQ Item */}
              <div className="accordion-item">
                <h3 className="accordion-header" id="headingTwo">
                  <Link
                    to="#"
                    className="accordion-button collapsed"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTwo"
                    aria-expanded="false"
                    aria-controls="collapseTwo"
                  >
                    Do you work with adults, adolescents, or children?
                  </Link>
                </h3>
                <div
                  id="collapseTwo"
                  className="accordion-collapse collapse"
                  data-bs-parent="#faq-details-one"
                >
                  <div className="accordion-body">
                    <div className="accordion-content">
                      <p>
                        Yes, we offer customized treatments specially designed
                        for sensitive skin using gentle, dermatologist-approved
                        products and techniques.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              {/* /FAQ Item */}
              {/* FAQ Item */}
              <div className="accordion-item">
                <h3 className="accordion-header" id="headingThree">
                  <Link
                    to="#"
                    className="accordion-button collapsed"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseThree"
                    aria-expanded="false"
                    aria-controls="collapseThree"
                  >
                    Is virtual therapy right for me?
                  </Link>
                </h3>
                <div
                  id="collapseThree"
                  className="accordion-collapse collapse"
                  data-bs-parent="#faq-details-one"
                >
                  <div className="accordion-body">
                    <div className="accordion-content">
                      <p>
                        Results vary depending on the treatment and skin
                        condition. Some treatments show immediate results, while
                        others may require multiple sessions.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              {/* /FAQ Item */}
              {/* FAQ Item */}
              <div className="accordion-item">
                <h3 className="accordion-header" id="headingFour">
                  <Link
                    to="#"
                    className="accordion-button collapsed"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseFour"
                    aria-expanded="false"
                    aria-controls="collapseFour"
                  >
                    Are your therapists licensed to practice?
                  </Link>
                </h3>
                <div
                  id="collapseFour"
                  className="accordion-collapse collapse"
                  data-bs-parent="#faq-details-one"
                >
                  <div className="accordion-body">
                    <div className="accordion-content">
                      <p>
                        Yes, we recommend a consultation to understand your skin
                        concerns and create a personalized treatment plan.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              {/* /FAQ Item */}
            </div>
          </div>
        </div>
      </div>
      {/* end row */}
    </div>
  </section>
  {/* End Faq Section */}
</>

  )
}

export default FaqSection